import {
	EventsState,
	SCHEDULE_ACTION_TYPES,
	ScheduleEventsAction,
} from '../../../../types/schedule'
import dayjs from 'dayjs'

const initialState: EventsState = {
	events: [],
	loadingEvents: true,
	time: dayjs().startOf('day').valueOf(),
	tableFilters: {
		category: [],
		status: [],
	},
	searchValue: '',
	calendarMode: 'month',
}

export default (
	state = initialState,
	action: ScheduleEventsAction
): EventsState => {
	switch (action.type) {
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_GET: {
			return {
				...state,
				events: action.payload,
				loadingEvents: false,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_GET_LOADING: {
			return {
				...state,
				loadingEvents: action.payload,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_SET_CALENDAR_TIME: {
			return {
				...state,
				time: action.payload,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_DELETE_EVENT: {
			const updatedEvents = state.events.filter(
				event => event._id !== action.payload
			)
			return {
				...state,
				events: updatedEvents,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_TABLE_SET_FILTER: {
			const newFilters = {
				...state.tableFilters,
				[action.payload.key]: [
					...state.tableFilters[action.payload.key],
					action.payload.value,
				],
			}

			return {
				...state,
				tableFilters: newFilters,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_TABLE_UNSET_FILTER: {
			const newFilters = {
				...state.tableFilters,
				[action.payload.key]: state.tableFilters[
					action.payload.key
				].filter(val => val !== action.payload.value),
			}

			return {
				...state,
				tableFilters: newFilters,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_SET_SEARCH_VALUE: {
			return {
				...state,
				searchValue: action.payload,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_CHANGE_MODE: {
			return {
				...initialState,
				calendarMode: action.payload,
			}
		}
		case SCHEDULE_ACTION_TYPES.SCHEDULE_EVENTS_RESET: {
			return initialState
		}
		default: {
			return state
		}
	}
}
